// 09-10 (Pau aprobó la maqueta: «el muñeco y la lista dicen lo mismo»). Lo que hace el muñeco en su mesa sale de
// la MISMA situación que la lista (marco/situacion.ts), no del estado visual S11: antes la etiqueta decía
// «Te ha escrito» y el muñeco seguía tecleando.
// 04-11 (visual.md, «el muñeco no dice lo mismo que su punto»): «llegando» lleva el punto verde de trabajando, así que
// teclea. El monitor encendido se fue con las mesas nuevas (vistas de frente, como en la maqueta aprobada): trabajar se
// dice con el gesto y con el punto de la etiqueta.
import type { Animacion } from '../../../lib/oficina/pixel-art';
import type { ContratadoDTO } from '../compartido/vocabulario';

export function poseDe(c: Pick<ContratadoDTO, 'situacion' | 'visual'>, aparcado = false): Animacion {
  // 04-11 (Pau aprobó «Aparcar»): el aparcado duerme en su mesa hasta que le escribas o pida algo.
  if (aparcado) return 'duerme';
  switch (c.situacion) {
    case 'trabajando':
    case 'llegando':
    case 'cerrando':
      return 'teclea';
    // Pide permiso o no puede seguir: levanta la vista, pensando (espera a Pau).
    case 'autorizacion':
    case 'bloqueado':
      return 'piensa';
    // Solo duerme si su proceso ha fallado de verdad; el resto de problemas (sin cupo, mensajes sin entregar,
    // dormido que el despertador levanta) los arregla la oficina: espera tranquilo.
    case 'problema':
      return c.visual === 'error' ? 'duerme' : 'lee';
    // Te ha escrito, sin nada pendiente o saliendo: en reposo, leyendo.
    default:
      return 'lee';
  }
}
